import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["$formControlUse"];
import { INPUT_DEFAULT_HEIGHT, INPUT_DEFAULT_PADDING_X } from 'HubStyleTokens/sizes';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const EXTRA_SMALL_BUTTON_HEIGHT = '26px';
// Can remove this manually prop-omitting nonsense when styled-components transient props are supported
// https://styled-components.com/docs/api#transient-props
// https://git.hubteam.com/HubSpot/Frontend/issues/1770
export const PositionedButtonContainer = styled(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
_ref => {
  let props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({}, props));
}).withConfig({
  displayName: "PositionedButtonContainer",
  componentId: "c8xs46-0"
})(["position:absolute;", " ", ""], ({
  $formControlUse
}) =>
// table cells don't have left padding on the input to consider
$formControlUse !== 'table-cell' ? `left: ${INPUT_DEFAULT_PADDING_X};` : '', ({
  $formControlUse
}) =>
// We have to account for the form control increasing the relative box height in the default and compact cases
// by using bottom positioning we can vertically align with the input and ignore the height added by the form control
['default', 'compact'].includes($formControlUse) ? `bottom: calc((${INPUT_DEFAULT_HEIGHT} - ${EXTRA_SMALL_BUTTON_HEIGHT}) / 2);` : '');